import { render, staticRenderFns } from "./direct-exchange.vue?vue&type=template&id=88ec5dcc&scoped=true&"
import script from "./direct-exchange.vue?vue&type=script&lang=js&"
export * from "./direct-exchange.vue?vue&type=script&lang=js&"
import style0 from "./direct-exchange.vue?vue&type=style&index=0&id=88ec5dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ec5dcc",
  null
  
)

export default component.exports